export enum HeroVariant {
  Form = "form",
  Redirect = "redirect",
  DetachedForm = "detachedForm",
  Filter = "filter",
  Promotion = "promotion",
  PromotionWithFilter = "promotionWithFilter"
}

export enum LayoutHero {
  Default = "default",
  DefaultWithQuote = "defaultWithQuote",
  Stacked = "stacked"
}
